import normalize from 'json-api-normalizer';
import Stage from './stage';
import AdditionalResource from './additional_resource';

//import { mapDebugActions } from '@/lib/debug.js';

export default class Program {
	static from (jsonapi) {
		let key = 'programs'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Program.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Program.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		let relationships = {}
		if (jsonapi.relationships && jsonapi.relationships['stages'] && normalizedJSONapi['stages'] && noRelationships == 0) {
			relationships['stages'] = {};
			jsonapi.relationships['stages'].data.forEach( function (rel) {
				relationships['stages'][rel.id] = Stage.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
			});
		}

		if (jsonapi.relationships && jsonapi.relationships['additionalResources'] && normalizedJSONapi['additionalResources'] && noRelationships == 0) {
			relationships['additionalResources'] = {};
			jsonapi.relationships['additionalResources'].data.forEach( function (rel) {
				relationships['additionalResources'][rel.id] = AdditionalResource.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
			});
		}

		return new Program( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, displayName, internalName, state, stages, additionalResources, enrolments, groupId, version, defaultProgramLength, description, language, forumConsent, sharedFile }) {
		this.id               = id ? id : -1;
		this.display_name     = displayName ? displayName : '';
		this.internal_name    = internalName ? internalName : '';
		this.group_id         = groupId ? groupId : 0;
		this.state            = state ? state : 'draft';
		this.stages           = stages ? stages : {};
		this.additional_resources = additionalResources ? additionalResources : {};
		this.version          = version ? version : 0;
		this.default_program_length = defaultProgramLength ? defaultProgramLength : 60480;
		this.description      = description ? description : null;
		this.enrolments       = enrolments ? enrolments : 0;
        this.language         = language ? language : null;
		this.forum_consent    = forumConsent ? forumConsent : null;
		this.shared_file	  = (sharedFile != null) ? sharedFile : null;
	}

	displayName() {
		return this.internal_name;
	}

	displayState() {
		return this.state.toUpperCase();
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		delete attributes.id;
		delete attributes.stages;

		return {data: {type: "programs", id: this.id, attributes: attributes}};
	}
}
